module.exports = "\n<button mat-icon-button  (click)=\"refreshWorkrequests()\">\n  <mat-icon class=\"icon\">refresh</mat-icon>\n</button>\n"